import { motion } from "framer-motion";
import { Mail } from "lucide-react";
import { BOOKING_EMAIL, IMAGES } from "@/data";
import BookingForm from "@/components/BookingForm";

const reveal = {
  hidden: { opacity: 0, y: 40 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: i * 0.1 },
  }),
};

export default function Booking() {
  return (
    <section
      id="booking"
      data-testid="booking-section"
      className="relative overflow-hidden border-t border-red-950/50"
    >
      <div className="absolute inset-0">
        <img
          src={IMAGES.stage}
          alt=""
          className="h-full w-full object-cover object-[50%_30%] opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#070707] via-[#070707]/90 to-[#070707]/75" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_20%_50%,rgba(200,16,46,0.22),transparent_60%)]" />
      </div>

      <div className="relative mx-auto grid max-w-7xl grid-cols-1 gap-12 px-5 py-28 sm:px-8 sm:py-36 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16">
        <div>
          <motion.p
            variants={reveal}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            className="font-mono-tac text-xs uppercase tracking-[0.35em] text-red-600"
          >
            03 — Booking
          </motion.p>
          <motion.h2
            variants={reveal}
            custom={1}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            className="font-display mt-4 text-5xl uppercase leading-[0.95] text-neutral-100 sm:text-7xl"
          >
            Portaci nella <span className="text-[#C8102E]">tua città</span>
          </motion.h2>
          <motion.p
            variants={reveal}
            custom={2}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            className="mt-6 max-w-md text-base leading-relaxed text-neutral-300"
          >
            Locali, festival, feste di piazza, barche: se c'è una presa di
            corrente, noi suoniamo. Compila il modulo — la richiesta ci arriva
            subito — oppure scrivici direttamente.
          </motion.p>
          <motion.a
            variants={reveal}
            custom={3}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            data-testid="booking-email-link"
            href={`mailto:${BOOKING_EMAIL}`}
            className="group mt-8 inline-flex items-center gap-3 border border-neutral-700 px-6 py-4 font-mono-tac text-sm tracking-[0.15em] text-neutral-300 transition-all duration-200 hover:border-red-600 hover:text-red-500"
          >
            <Mail className="h-4 w-4 text-red-700 group-hover:text-red-500" />
            {BOOKING_EMAIL}
          </motion.a>
        </div>

        <motion.div
          variants={reveal}
          custom={2}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          <BookingForm />
        </motion.div>
      </div>
    </section>
  );
}
